import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import openDocumentViewer from './utils/openDocumentViewer';
import { LanguageProvider } from './context/LanguageContext';
import SiteLayout from './layout/SiteLayout';
import Home from './pages/Home';

const AboutUs = lazy(() => import('./pages/AboutUs'));
const ImmigrationServices = lazy(() => import('./pages/ImmigrationServices'));
const TouristInformation = lazy(() => import('./pages/TouristInformation'));
const ApiPnr = lazy(() => import('./pages/ApiPnr'));
const ServiceFee = lazy(() => import('./pages/ServiceFee'));
const PublicNotice = lazy(() => import('./pages/PublicNotice'));
const PassportIssuedList = lazy(() => import('./pages/PassportIssuedList'));
const ELibrary = lazy(() => import('./pages/ELibrary'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const Sitemap = lazy(() => import('./pages/Sitemap'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const CopyrightStatement = lazy(() => import('./pages/CopyrightStatement'));
const Disclaimer = lazy(() => import('./pages/Disclaimer'));
const FAQ = lazy(() => import('./pages/FAQ'));
const NewsDetail = lazy(() => import('./pages/NewsDetail'));
const Search = lazy(() => import('./pages/Search'));
const DocumentViewer = lazy(() => import('./pages/DocumentViewer'));

function App() {
  useEffect(() => {
    const handleClick = (e) => {
      const anchor = e.target.closest('a[href]');
      if (!anchor) return;

      const href = anchor.getAttribute('href') || '';
      if (!href.toLowerCase().endsWith('.pdf')) return;

      e.preventDefault();
      const title = anchor.textContent?.trim() || anchor.getAttribute('title') || 'Document';
      openDocumentViewer(href, title);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
            <div style={{ width: '40px', height: '40px', border: '3px solid #e3f2fd', borderTopColor: '#286ea3', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
          </div>
        }>
        <Routes>
        <Route path="/" element={<SiteLayout />}>
          <Route index element={<Home />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="immigration-services" element={<ImmigrationServices />} />
          <Route path="tourist-info" element={<TouristInformation />} />
          <Route path="api-pnr" element={<ApiPnr />} />
          <Route path="service-fee" element={<ServiceFee />} />
          <Route path="public-notice" element={<PublicNotice />} />
          <Route path="passport-issued-list" element={<PassportIssuedList />} />
          <Route path="news/:id" element={<NewsDetail />} />
          <Route path="e-library" element={<ELibrary />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="sitemap" element={<Sitemap />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="copyright-statement" element={<CopyrightStatement />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="search" element={<Search />} />
        </Route>
        <Route path="/document-viewer" element={<DocumentViewer />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
